import React from 'react';
import styled from '@emotion/styled';
import Layout from '../components/layout/Layout';
import Seo from '../components/seo/Seo';
import DemoSchedulingForm from '../components/demo-scheduling/DemoSchedulingForm';
import {
  WebsiteSection,
  WebsiteSectionContainer,
  WebsitePageHeader,
  WebsitePageTitle,
  WebsitePageIntro,
} from '../components/common/websiteSection';

const FormWrapper = styled.div`
  max-width: 560px;
  margin: 0 auto;
`;

export default function BookDemoPage() {
  return (
    <Layout>
      <Seo
        title="Book a Demo"
        description="Schedule a personalized demo of Neat Schedule. See how online booking, staff scheduling, and client management can help your business."
        canonicalPath="/book-demo"
        keywords={['book a demo', 'Neat Schedule demo', 'scheduling software demo', 'appointment booking demo']}
      />
      <WebsiteSection>
        <WebsiteSectionContainer>
          <WebsitePageHeader>
            <WebsitePageTitle>Book a Demo</WebsitePageTitle>
            <WebsitePageIntro>
              Pick a time that works for you and we&apos;ll walk you through Neat Schedule — tailored to how your business runs.
            </WebsitePageIntro>
          </WebsitePageHeader>

          <FormWrapper>
            <DemoSchedulingForm />
          </FormWrapper>
        </WebsiteSectionContainer>
      </WebsiteSection>
    </Layout>
  );
}
